class Tabs {
  constructor() {
    this.selectors = {
      component: '.tab-list',
      tabButton: '.tab-list__toggle',
      tabItem: '.tab-list__item',
      tabItemActive: '.tab-list__item--active',
      tabContent: '.tab-list__content',
      tabContentInactive: '.tab-list__item:not(.tab-list__item--active) .tab-list__content',
    };
  }

  // accessibility: apply styling on page load
  // if JS is disabled, content will still show
  handleStylesOnLoad() {
    $(this.selectors.component).addClass('js-loaded');
    $(this.selectors.tabContentInactive).hide();
  }

  setTabItemHeight(activeItem) {
    const buttonHeight = activeItem.find(this.selectors.tabButton).height();
    const contentHeight = activeItem.find(this.selectors.tabContent).height();

    const itemHeight = buttonHeight + contentHeight;

    activeItem.height(itemHeight);
  }

  tabItemToggle() {
    $(this.selectors.tabButton).on('click', (event) => {
      $(event.currentTarget).closest(this.selectors.tabItem).addClass('tab-list__item--active')
        .siblings('.tab-list__item--active').removeClass('tab-list__item--active')
        .find(this.selectors.tabContent).fadeOut(100);

      $(event.currentTarget)
        .closest(this.selectors.tabItem)
        .find(this.selectors.tabContent).fadeIn(100);

      $(event.currentTarget).attr('aria-selected', 'true')
        .closest(this.selectors.tabItem)
        .siblings()
        .find(this.selectors.tabButton).attr('aria-selected', 'false');

      $(event.currentTarget).closest(this.selectors.tabItem)
        .siblings().css('height', 'fit-content');

      this.setTabItemHeight($(event.currentTarget).closest(this.selectors.tabItem));
      this.submitResetHeight($(event.currentTarget).closest(this.selectors.tabItem));
    });
  }

  // if a tab conteins a form
  // re-set height if errors on submit
  // See T-MYT-INT-UPD
  submitResetHeight(activeItem) {
    if (activeItem.find('button[type="submit"]') !== null) {
      activeItem.find('button[type="submit"]').on('click', () => {
        setTimeout(() => {
          this.setTabItemHeight(activeItem);
        }, 40);
      });
    }
  }

  // if it affects performance, remove
  resizeResetHeight() {
    $(window).on('resize', () => {
      // if ($(window).innerWidth() >= 767) {
      this.setTabItemHeight($(this.selectors.tabItemActive));
      // }
    });
  }

  // checks if tab is opened via url and toggle
  tabItemCurrent() {
    const tabId = new URLSearchParams(document.location.search).get('tab');

    if (tabId === null) return;

    // if tab matches an ID in the page, trigger click
    if ($(this.selectors.tabButton).is(`#${tabId}`)) {
      $(`#${tabId}`).trigger('click');
    }
  }

  init() {
    this.handleStylesOnLoad();
    setTimeout(() => {
      this.setTabItemHeight($(this.selectors.tabItemActive));
    }, 150);
    this.submitResetHeight($(this.selectors.tabItemActive));
    this.tabItemToggle();
    this.resizeResetHeight();
    this.tabItemCurrent();
  }
}

export default new Tabs();
